import { createContext } from 'react';

interface PermissionContextType {
  hasPermission: (key: string) => boolean;
}

export const PermissionContext = createContext<PermissionContextType>({
  hasPermission: () => false,
});

export default PermissionContext;
